import { EcosystemReviewPopover } from 'marketplace-ui-reviews/components/wizard/EcosystemReviewPopover';
import { ReviewTagsInput } from 'trellis-ecosystem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UsageTracker from '../../../utils/UsageTracker';
import { AcademyRatingsTypes } from '../../../constants/RatingsAndReviewConstants';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RatingsPopoverButton = ({
  children,
  contentId,
  displayPopover,
  handleOnClose,
  handleOnSuccess,
  header,
  previousReview,
  rating,
  ratingsReviewGroupKey,
  reviewTags,
  reviewType
}) => {
  const handleReviewFormatter = review => {
    const newReview = Object.assign({}, review);
    newReview.ratings.OVERALL = rating;
    return newReview;
  };
  const isReviewEditing = !!previousReview;
  const previousRatingId = previousReview === null || previousReview === void 0 ? void 0 : previousReview.id;
  const originalReview = previousReview && {
    content: {},
    ratings: {
      OVERALL: previousReview.ratings.OVERALL
    },
    tags: previousReview.tags
  };
  const trackingContentType = reviewType === AcademyRatingsTypes.ACADEMY_COURSE ? 'TRACK' : reviewType === AcademyRatingsTypes.ACADEMY_LESSON ? 'LESSON' : 'SHORT_FORM_CONTENT';
  const onOptionClick = () => UsageTracker.track('contentInteraction', {
    action: 'ratings-tag-option-clicked',
    contentId,
    contentType: trackingContentType
  });
  return /*#__PURE__*/_jsx(EcosystemReviewPopover, {
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.ratingsAndReview.selectAll"
      }), /*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(ReviewTagsInput, {
          fieldKey: ratingsReviewGroupKey,
          onClick: onOptionClick,
          options: reviewTags
        })
      })]
    }),
    editReason: "OTHER",
    errorAlertTitle: I18n.text('learningCenter.ratingsAndReview.alerts.errors.title'),
    headerContent: header,
    isEditing: isReviewEditing,
    offeringId: contentId,
    onClose: handleOnClose,
    onSuccess: handleOnSuccess,
    originalReview: originalReview,
    overrideSubmitValidation: isReviewEditing,
    popoverProps: {
      open: displayPopover,
      inlineSize: '400px'
    },
    reviewFormatter: handleReviewFormatter,
    reviewId: previousRatingId,
    reviewType: reviewType,
    submitButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.ratingsAndReview.submit"
    }),
    successAlertMessage: " ",
    successAlertTitle: I18n.text('learningCenter.ratingsAndReview.alerts.success.title'),
    validationSchema: {
      ratings: {
        [ratingsReviewGroupKey]: {
          required: false
        }
      }
    },
    children: children
  });
};
export default RatingsPopoverButton;